<template>
  <div>
    <footer>
      <div class="container">
        <div class="row d-flex justify-content-center align-items-center  py-3 ">
          <div class="col-6text-center text-center ">
            <a target="_blank" href="./Terminos y Condiciones CCH.pdf" class="blanco terminos">Términos y Condiciones</a>
          </div>
           <div class="col-6 blanco text-right blanco">
            GCC 2022
          </div>
        </div>
      </div>
    </footer>

    <span class="loading" v-bind:class="{active: this.$store.state.loading}">
      <img src="../assets/imgs/DualRing-1.1s-200px.svg" alt="loading" />
    </span>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
  methods: {},
};
</script>

